import React from "react";
import { Row, Col } from "antd";
import useCurrentWidth from "../../Common/Hooks/useCurrentWidth.jsx";
import "./UseCases.scss";
import {
  TransDiscount,
  PremiumFeature,
  GovVoting,
  StakingRewards,
  MerchantPayment,
  CrossBorderTrans,
} from "../../assets/StoreAsset/StoreAssets";

function UseCases() {
  const width = useCurrentWidth();

  // Dynamic gutter based on width
  const gutterHorizontal = width <= 1650 ? 20 : 50;
  const gutterVertical = width <= 1650 ? 20 : 56;

  const data = [
    {
      id: 1,
      img: <TransDiscount />,
      title: "Transaction Fee Discounts",
      detail: "Carry out transactions at reduced fee with UWPS tokens.",
    },
    {
      id: 2,
      img: <PremiumFeature />,
      title: "Premium Feature Access",
      detail: "Unlock elite financial tools and services through UWPS holdings.",
    },
    {
      id: 3,
      img: <StakingRewards />,
      title: "Staking & Rewards",
      detail: "Lock UWPS tokens to earn continuous returns and related privileges.",
    },
    {
      id: 4,
      img: <GovVoting />,
      title: "Governance & Voting",
      detail: "Become a part of UWPS platform evolution through direct voting.",
    },
    {
      id: 5,
      img: <MerchantPayment />,
      title: "Merchant Payments",
      detail: "Conduct fast and easy business transactions with UWPS tokens.",
    },
    {
      id: 6,
      img: <CrossBorderTrans />,
      title: "Cross-Border Transactions",
      detail: "Send and receive money globally and instantly with UWPS transfers.",
    },
  ];

  return (
    <div className="useCases">
      <h2 className="useCases_token">Use<span> Cases of UWPS Token</span></h2>
      <p className="useCases_text">UWPS token delivers tangible utility across multiple use cases.</p>
      <div className="container">
        <Row gutter={[gutterHorizontal, gutterVertical]}>
          {data?.map((item) => (
            <Col xs={24} sm={12} lg={8} key={item.id}>
              <div className="useCases_inner">
                <div className="useCases_inner_img">{item.img}</div>
                <h4>{item.title}</h4>
                <p>{item.detail}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default UseCases;
